import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import pe from "./pe.json";
import en from "./en.json";

export const SUPPORTED_LANGUAGES = ["pe", "en"];
export const DEFAULT_LANGUAGE = "pe";

i18n.use(initReactI18next).init({
  resources: {
    pe: { translation: pe },
    en: { translation: en },
  },
  lng: DEFAULT_LANGUAGE,
  fallbackLng: DEFAULT_LANGUAGE,
  interpolation: { escapeValue: false },
  returnObjects: true,
});

export default i18n;
